"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIControllerPM = void 0;
const gs = require("@ivanlog/gs");
const LayoutDesktop_1 = require("../../classes/com/LayoutDesktop");
const GUIController_1 = require("../../classes/appControllers/GUIController");
class GUIControllerPM extends GUIController_1.GUIController {
    constructor(app) {
        super(app);
    }
    initialize() {
        super.initialize();
        this._layoutMain = new LayoutDesktop_1.LayoutDesktop();
        this._layoutMain.ctrls.bottomMenu.initialize(this._layoutMain.ctrls.topMenuMobile);
        this.layouts.set("main", this._layoutMain);
    }
    setSearchQuery(query) {
        this._layoutMain.ctrls.topMenu.ctrls.iSearchQuery.value = query;
        this._layoutMain.ctrls.topMenuMobile.ctrls.iSearchQuery.value = query;
    }
    setFavoriteCount(count) {
        const topFavorite = this._layoutMain.ctrls.topMenu.ctrls.lFavouriteCount;
        const bottomFavorite = this._layoutMain.ctrls.bottomMenu.ctrls.lFavouriteCount;
        bottomFavorite.showSet(count > 0);
        topFavorite.showSet(count > 0);
        bottomFavorite.text = topFavorite.text = count + "";
    }
    setCartCount(count) {
        const topCart = this._layoutMain.ctrls.topMenu.ctrls.lCartCount;
        const bottomCart = this._layoutMain.ctrls.bottomMenu.ctrls.lCartCount;
        bottomCart.showSet(count > 0);
        topCart.showSet(count > 0);
        bottomCart.text = topCart.text = count + "";
    }
    hideBreadcrums() {
        this._layoutMain.ctrls.breadcrumbs.hide();
    }
    setBreadcrumbs(crumbs) {
        const bc = this._layoutMain.ctrls.breadcrumbs;
        bc.ctrls.list.html = '';
        for (const step of crumbs) {
            const li = gs.w(gs.html.tag("li"));
            li.append(gs.html.a({ href: step.url }, step.name));
            bc.ctrls.list.append(li);
        }
        this._layoutMain.ctrls.breadcrumbs.show();
    }
    showBreadcrums() {
        super.showBreadcrums();
        this._layoutMain.ctrls.breadcrumbs.show();
    }
    showPopAuth(callback = undefined) {
        this._layoutMain.ctrls.cmpPopRightAuth.reset(callback);
        this._layoutMain.ctrls.cmpPopRightAuth.show();
    }
}
exports.GUIControllerPM = GUIControllerPM;
//# sourceMappingURL=GUIControllerPM.js.map